var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"my-modal-divvy-admin",attrs:{"title":"System Message"}},[_c('p',[_vm._v(_vm._s(_vm.getModalMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }